const route = {
	path: ':codeApp/sidebar',
	name: 'page-sidebar',
	meta: {
		title: 'Sidebar',
	},
	props: true,
	component: () => import('@/pages/sidebar/page-sidebar'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/sidebar.js